import moment from "moment";

function getAmPmFrom24Hour(value: string): string {
  return moment(value, 'HH:mm').format('hh:mm A');
}

export default getAmPmFrom24Hour;